import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE } from './api/client';
import './AdminDashboard.css';
import JobForm from './JobForm';
import { useNavigate } from 'react-router-dom';
import AdminJobList from './AdminJobList';
import AdminJobApplication from './AdminJobApplication';

const AdminDashboard = () => {
    const [jobListings, setJobListings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedJobId, setSelectedJobId] = useState(null);
    const [userRole, setUserRole] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const role = localStorage.getItem('role');
        setUserRole(role);

        if (role !== 'admin') {
            navigate('/');
            return;
        }

        const fetchData = async () => {
            try {
                const token = localStorage.getItem('token');
                const jobsRes = await axios.get(`${API_BASE}/api/job/admin/jobs`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                console.log("Fetched jobs in AdminDashboard:", jobsRes.data);
                setJobListings(jobsRes.data);
            } catch (error) {
                console.error('Error fetching jobs:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [navigate]);

    const handleJobCreation = (newJob) => {
        setJobListings((prevListings) => [...prevListings, newJob]);
    };

    if (loading) return <div>Loading...</div>;

    return (
        <div className="admin-dashboard">
            <h1 className="admin-h1">Admin Dashboard</h1>
            <section>
                <JobForm onJobCreated={handleJobCreation} />
                {!selectedJobId ? (
                <AdminJobList onSelectJob={setSelectedJobId} />
            ) : (
                <div>
                    <button onClick={() => setSelectedJobId(null)} className="admin-submit">
                        Back to Jobs
                    </button>
                    <AdminJobApplication jobId={selectedJobId} />
                </div>
            )}
        
            </section>
            </div>    
    );
};

export default AdminDashboard;
